export const EVENT_COVER_HEIGHT = Object.freeze({
  s: 170,
  m: 149,
  l: 157,
  xl: 168,
});

export const NEWS_COVER_HEIGHT = Object.freeze({
  s: 143,
  m: 133,
  l: 116,
  xl: 168,
});
